module.exports = __webpack_public_path__ + "static/media/AugustaMargaretRiverTimes-socshare-min.315686f1.jpg";